/* EBONFORM — saved works (wishlist), saved cart and "welcome back".
   Everything is kept in this browser on this device (localStorage), so it survives closing the site. */
(() => {
  if (window.__ebfWishlist) return; window.__ebfWishlist = true;
  const WL = 'ebf_wishlist_v1', CB = 'ebf_cart_backup_v1', LV = 'ebf_last_visit_v1', SS = 'ebf_welcome_shown';
  const get = (k, d) => { try { const v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } };
  const set = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) => 'Rs. ' + (Number(cents || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const handleFrom = (href) => { const m = String(href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; };
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19.5s-7-4.35-7-9.6A3.9 3.9 0 0 1 12 7.6a3.9 3.9 0 0 1 7 2.3c0 5.25-7 9.6-7 9.6Z"/></svg>';

  let list = get(WL, []).filter((h) => typeof h === 'string');
  const has = (h) => list.includes(h);
  const save = () => { set(WL, list); render(); fillCartSaved(); };
  const pulse = (el) => { if (!el) return; el.classList.remove('ewl-pop'); void el.offsetWidth; el.classList.add('ewl-pop'); };
  const toggle = (h, btn) => {
    if (!h) return;
    const adding = !has(h);
    list = adding ? [h, ...list] : list.filter((x) => x !== h);
    save();
    if (adding) { pulse(btn); pulse(hdrBtn); fetchProduct(h); }
  };

  /* ---------- header: saved works button ---------- */
  const actions = document.querySelector('.efh-actions');
  let hdrBtn = null;
  if (actions && !actions.querySelector('.ewl-hdr')) {
    hdrBtn = document.createElement('button');
    hdrBtn.type = 'button'; hdrBtn.className = 'ewl-hdr'; hdrBtn.setAttribute('aria-label', 'Saved works');
    hdrBtn.innerHTML = heart + '<span class="ewl-hdr__count" hidden></span>';
    const cart = actions.querySelector('.efh-cart');
    actions.insertBefore(hdrBtn, cart || null);
    hdrBtn.addEventListener('click', () => openDrawer());
  }

  /* ---------- currency: header on desktop, footer on mobile ---------- */
  (() => {
    const cur = document.querySelector('.efh-actions [data-efcurrency]');
    const shell = document.querySelector('.eflv-footer .eflv-shell');
    if (!cur || !shell) return;
    const home = document.createComment('efcurrency-home');
    cur.parentNode.insertBefore(home, cur);
    const row = document.createElement('div');
    row.className = 'eflv-currency';
    row.innerHTML = '<span class="eflv-currency__label">Currency</span>';
    shell.insertBefore(row, shell.querySelector('.eflv-bottom'));
    const mq = matchMedia('(max-width:900px)');
    const place = () => {
      const mobile = mq.matches;
      cur.classList.toggle('efcurrency--footer', mobile);
      cur.classList.toggle('efcurrency--header', !mobile);
      cur.dataset.efcurrencyPlacement = mobile ? 'footer' : 'header';
      if (mobile) row.appendChild(cur); else home.parentNode.insertBefore(cur, home);
    };
    place();
    mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place);
  })();

  /* ---------- hearts on product cards ---------- */
  const decorateCards = (scope) => {
    (scope || document).querySelectorAll('.efh2-work-card, .efc-card, .ecl .efh2-work-card').forEach((card) => {
      if (card.querySelector('.ewl-card')) return;
      const a = card.querySelector('a[href*="/products/"]'); const h = a && handleFrom(a.getAttribute('href'));
      const host = card.querySelector('figure, .efc-card__gallery');
      if (!h || !host) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'ewl-card'; b.dataset.handle = h; b.innerHTML = heart;
      b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); toggle(h, b); });
      host.appendChild(b);
    });
    render();
  };

  /* ---------- product page: "Save to wishlist" ---------- */
  const pdpHandle = /\/products\//.test(location.pathname) ? handleFrom(location.pathname) : '';
  if (pdpHandle) {
    const form = document.querySelector('main form[action*="/cart/add"]');
    const top = document.querySelector('main .pdp-info__top');
    if ((top || form) && !document.querySelector('.ewl-save')) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'ewl-save'; b.dataset.handle = pdpHandle;
      b.innerHTML = heart;
      b.addEventListener('click', () => toggle(pdpHandle, b));
      /* sits top-right beside the edition line and title, like a maison product page */
      if (top) { b.classList.add('ewl-save--top'); top.classList.add('ewl-has-save'); top.prepend(b); }
      else form.insertAdjacentElement('afterend', b);
    }
  }

  /* ---------- one saved work as a list row ---------- */
  function itemRow(p, h) {
    if (!p) return '';
    const img = p.featured_image ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
    const v = (p.variants || []).find((x) => x.available);
    return '<li class="ewl-item">' +
      '<a class="ewl-item__media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + (img.includes('?') ? '&' : '?') + 'width=300" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<div class="ewl-item__info"><a class="ewl-item__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<p class="ewl-item__price">' + money(p.price) + '</p>' +
      '<div class="ewl-item__actions">' + (v ? '<button type="button" class="ewl-link" data-ewl-add="' + v.id + '" data-ewl-handle="' + esc(h) + '">Add to cart</button>' : '<span class="ewl-muted">Sold out</span>') +
      '<button type="button" class="ewl-link ewl-link--quiet" data-ewl-remove="' + esc(h) + '">Remove</button></div></div></li>';
  }

  /* ---------- drawer ---------- */
  const drawer = document.createElement('div');
  drawer.className = 'ewl-drawer'; drawer.hidden = true;
  drawer.innerHTML = '<div class="ewl-drawer__veil" data-ewl-close></div><aside class="ewl-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="ewl-title">' +
    '<div class="ewl-drawer__top"><p class="ewl-kicker">Saved on this device</p><h2 id="ewl-title" class="ewl-title">Saved works</h2>' +
    '<button type="button" class="ewl-x" data-ewl-close aria-label="Close"><svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13"/></svg></button></div>' +
    '<div class="ewl-drawer__body" data-ewl-body></div></aside>';
  document.body.appendChild(drawer);
  const body = drawer.querySelector('[data-ewl-body]');
  let lastFocus = null;
  const PC = 'ebf_wl_products_v1';
  const stored = (() => { try { return JSON.parse(sessionStorage.getItem(PC)) || {}; } catch (e) { return {}; } })();
  const keep = () => { try { sessionStorage.setItem(PC, JSON.stringify(stored)); } catch (e) {} };
  const slim = (p) => p && ({ title: p.title, url: p.url, featured_image: p.featured_image, price: p.price, variants: (p.variants || []).map((v) => ({ id: v.id, available: v.available })) });
  const cache = {};
  const fetchProduct = (h) => cache[h] || (cache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.json() : null)).then((p) => { if (p) { stored[h] = slim(p); keep(); } return p ? stored[h] : (stored[h] || null); })
    .catch(() => stored[h] || null));

  const fillDrawer = async () => {
    if (!list.length) {
      body.innerHTML = '<div class="ewl-empty"><p>Nothing saved yet.</p><p class="ewl-muted">Tap the heart on any work to keep it here.</p><a class="ewl-btn" href="' + root + 'collections/all">Explore the works</a></div>';
      return;
    }
    const ready = list.every((h) => stored[h]);
    if (!ready) body.innerHTML = '<p class="ewl-muted ewl-loading">Loading…</p>';
    const items = ready ? list.map((h) => stored[h]) : await Promise.all(list.map(fetchProduct));
    const rows = items.map((p, i) => itemRow(p, list[i])).join('');
    if (!rows) { body.innerHTML = '<div class="ewl-empty"><p>Saved works could not load.</p><p class="ewl-muted">Please check your connection and try again.</p></div>'; return; }
    body.innerHTML = '<ul class="ewl-list">' + rows + '</ul><a class="ewl-btn ewl-btn--ghost" href="' + root + 'cart">View cart</a>';
  };

  /* add / remove buttons, shared by the drawer and the cart page list */
  const listClick = async (e) => {
    const rm = e.target.closest('[data-ewl-remove]');
    if (rm) { list = list.filter((x) => x !== rm.dataset.ewlRemove); save(); if (!drawer.hidden) fillDrawer(); return; }
    const add = e.target.closest('[data-ewl-add]');
    if (add) {
      add.disabled = true; add.textContent = 'Adding…';
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(add.dataset.ewlAdd), quantity: 1 }] }) });
        if (!r.ok) throw new Error('add');
        /* moved into the cart, so it leaves the saved list */
        const h = add.dataset.ewlHandle;
        if (h) { list = list.filter((x) => x !== h); set(WL, list); }
        if (onCartPage) location.reload(); else location.href = root + 'cart';
      } catch (err) { add.disabled = false; add.textContent = 'Try again'; }
    }
  };
  body.addEventListener('click', listClick);

  const onKey = (e) => { if (e.key === 'Escape') closeDrawer(); };
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.hidden = false; fillDrawer();
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.documentElement.classList.add('ewl-lock');
    document.addEventListener('keydown', onKey);
    setTimeout(() => drawer.querySelector('.ewl-x').focus({ preventScroll: true }), 50);
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ewl-lock');
    document.removeEventListener('keydown', onKey);
    setTimeout(() => { drawer.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  drawer.querySelectorAll('[data-ewl-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  window.EbonformWishlist = { open: openDrawer };

  /* ---------- cart page: saved works listed under the cart ---------- */
  const onCartPage = /\/cart\/?$/.test(location.pathname);
  let cartBox = null;
  if (onCartPage) {
    cartBox = document.createElement('section');
    cartBox.className = 'ewl-cartsaved'; cartBox.id = 'saved-works'; cartBox.hidden = true;
    cartBox.setAttribute('aria-labelledby', 'ewl-cartsaved-title');
    (document.querySelector('main') || document.body).appendChild(cartBox);
    cartBox.addEventListener('click', listClick);
  }
  async function fillCartSaved() {
    if (!cartBox) return;
    const head = '<div class="ewl-cartsaved__head"><h2 id="ewl-cartsaved-title" class="ewl-cartsaved__title">Saved works</h2>' +
      '<span class="ewl-cartsaved__count">' + list.length + (list.length === 1 ? ' work' : ' works') + '</span></div>';
    if (!list.length) {
      cartBox.hidden = false;
      cartBox.innerHTML = head.replace(/<span class="ewl-cartsaved__count">[^<]*<\/span>/, '') + '<p class="ewl-muted">Nothing saved yet. Tap the heart on any work to keep it here.</p>';
      return;
    }
    cartBox.hidden = false;
    const ready = list.every((h) => stored[h]);
    if (!ready) cartBox.innerHTML = head + '<p class="ewl-muted ewl-loading">Loading…</p>';
    const handles = list.slice();
    const items = ready ? handles.map((h) => stored[h]) : await Promise.all(handles.map(fetchProduct));
    const rows = items.map((p, i) => itemRow(p, handles[i])).join('');
    cartBox.innerHTML = head + (rows ? '<ul class="ewl-list">' + rows + '</ul>' : '<p class="ewl-muted">Saved works could not load. Please try again.</p>');
  }

  /* ---------- state on every heart ---------- */
  function render() {
    document.querySelectorAll('.ewl-card, .ewl-save').forEach((b) => {
      const on = has(b.dataset.handle);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Remove from saved works' : 'Save this work');
    });
    if (hdrBtn) {
      const c = hdrBtn.querySelector('.ewl-hdr__count');
      c.hidden = !list.length; c.textContent = list.length;
      hdrBtn.classList.toggle('has-items', list.length > 0);
      hdrBtn.setAttribute('aria-label', 'Saved works' + (list.length ? ', ' + list.length : ''));
    }
  }

  /* ---------- cart: keep a copy so it can be restored ---------- */
  const syncCart = async () => {
    let cart = null;
    try { cart = await (await fetch(root + 'cart.js', { credentials: 'same-origin' })).json(); } catch (e) { return null; }
    const backup = get(CB, null);
    if (cart && cart.item_count === 0 && backup && backup.token !== cart.token && backup.items && backup.items.length) {
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: backup.items }) });
        if (r.ok) { cart = await (await fetch(root + 'cart.js')).json(); const n = document.querySelector('.efh-cart'); if (n && cart.item_count && !n.querySelector('.efh-cart__count')) { const s = document.createElement('span'); s.className = 'efh-cart__count'; s.textContent = cart.item_count; n.appendChild(s); } }
      } catch (e) {}
    }
    if (cart) set(CB, { token: cart.token, items: (cart.items || []).map((i) => ({ id: i.variant_id, quantity: i.quantity })), at: Date.now() });
    return cart;
  };

  /* ---------- welcome back ---------- */
  const welcome = (cart) => {
    const last = get(LV, 0); const now = Date.now(); set(LV, now);
    let shown = false; try { shown = sessionStorage.getItem(SS) === '1'; } catch (e) {}
    if (shown || !last || now - last < 30 * 60 * 1000) return;
    if (/\/(cart|checkout)/.test(location.pathname)) return;
    const n = cart ? cart.item_count : 0;
    if (!list.length && !n) return;
    try { sessionStorage.setItem(SS, '1'); } catch (e) {}
    const parts = [];
    if (list.length) parts.push(list.length + (list.length === 1 ? ' saved work' : ' saved works'));
    if (n) parts.push(n + (n === 1 ? ' piece' : ' pieces') + ' in your cart');
    const t = document.createElement('div');
    t.className = 'ewl-welcome'; t.setAttribute('role', 'status');
    t.innerHTML = '<button type="button" class="ewl-x" aria-label="Close"><svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13"/></svg></button>' +
      '<p class="ewl-kicker">EBONFORM</p><p class="ewl-welcome__title">Welcome back.</p><p class="ewl-muted">You have ' + parts.join(' and ') + '.</p>' +
      '<div class="ewl-welcome__links">' + (list.length ? '<button type="button" class="ewl-link" data-ewl-open>Saved works</button>' : '') + (n ? '<a class="ewl-link" href="' + root + 'cart">View cart</a>' : '') + '</div>';
    document.body.appendChild(t);
    requestAnimationFrame(() => t.classList.add('is-in'));
    const bye = () => { t.classList.remove('is-in'); setTimeout(() => t.remove(), 400); };
    t.querySelector('.ewl-x').addEventListener('click', bye);
    const o = t.querySelector('[data-ewl-open]'); if (o) o.addEventListener('click', () => { bye(); openDrawer(); });
    setTimeout(bye, 12000);
  };

  const start = async () => {
    decorateCards(document);
    if (cartBox) {
      await fillCartSaved();
      if (location.hash === '#saved-works') cartBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    new MutationObserver((m) => { if (m.some((x) => x.addedNodes.length)) decorateCards(document); }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    const warm = () => list.forEach((h) => { if (!stored[h]) fetchProduct(h); });
    (window.requestIdleCallback || ((f) => setTimeout(f, 600)))(warm);
    if (hdrBtn) { hdrBtn.addEventListener('pointerenter', warm, { once: true }); hdrBtn.addEventListener('touchstart', warm, { once: true, passive: true }); }
    const cart = await syncCart();
    welcome(cart);
  };
  addEventListener('storage', (e) => { if (e.key === WL) { list = get(WL, []); render(); fillCartSaved(); } });
  start();
})();
